import { DbTypeEnum } from '@zenware/stackshare';
import { baseCfg } from '../env/base';
import { iEnvConfig, iServerConfig } from '../envConfigs/iEnvConfig.interface';
import { PassportStrategiesEnum } from '../server/enumerators/passport-strategies.enum';

// These values are expected to be available to both the client and the server
// No Security INFO to be captured here.
export const envCfg: iEnvConfig = {
  // NOTE: Hack with base config reference is used instead of object assign or spread
  // due to AGM not recognizing the API key with this wrapper in place.
  API_PORT: 9001,
  API_SVR: baseCfg.API_SVR,
  API_UI: baseCfg.API_UI,
  APP_VERSION: baseCfg.APP_VERSION,
  CONFIG_SOURCE: 'subscriptionConfig',
  ENV: 'TRIAL',
  FIREBASE: {
    apiKey: 'AIzaSyAUuJGp4vTRS99n550bqL-9odYyWCjhkFM',
    appId: '1:678733298034:web:f61cd15ff6a7d9da52c5eb',
    authDomain: 'harvestpointtest.firebaseapp.com',
    databaseURL: 'https://harvestpointtest.firebaseio.com',
    messagingSenderId: '678733298034',
    projectId: 'harvestpointtest',
    storageBucket: 'harvestpointtest.appspot.com'
  },
  GOOGLE_API_KEY: baseCfg.GOOGLE_API_KEY,
  production: baseCfg.production,
  SEED_VERSION: baseCfg.SEED_VERSION,
  SVR_PFIX: baseCfg.SVR_PFIX,
  STORE_ID_FIELDNAME: baseCfg.STORE_ID_FIELDNAME,
  STORE_ID_PLACEHOLDER: baseCfg.STORE_ID_PLACEHOLDER
};

export const serverCfg: iServerConfig = {
  DB_URL: 'localhost',
  DB_PORT: 3306,
  DB_NAME: 'hpoint-test',
  DB_USERNAME: 'zenware',
  DB_TYPE: DbTypeEnum.mySql,
  EMAIL_TO: 'harvestpointdevs@zenware.com',
  EMAIL_HOST: 'smtp-relay.gmail.com',
  EMAIL_PORT: 587,
  EMAIL_USER: 'davewasden@harvestpointsoftware.com',
  FB_CRED_FILE: 'harvestpointtest-87dd09325416.json',
  FBASE_UID: 'eventPublishUser',
  NODE_VERSION: 'v20.19.5',
  LOG_LEVEL: 'TRACE',
  PASSPORT_STRATEGY: PassportStrategiesEnum.firebase,
  SECURITY_PATH: 'security',
  SRCPWD_PATH: '../../envConfigs/sourcePasswords.json',
  TEMP_PUB_URL: 'https://appv2test.harvestpointsoftware.com'
};
